export const scopeLabels = {
  protocol: 'Protocol',
  user: 'User',
  tenant: 'Tenant',
  operator: 'Operator',
};

export const scopeClasses = {
  protocol: 'border-cyan-300/30 bg-cyan-300/10 text-cyan-100',
  user: 'border-emerald-300/30 bg-emerald-300/10 text-emerald-100',
  tenant: 'border-indigo-300/30 bg-indigo-300/10 text-indigo-100',
  operator: 'border-amber-300/30 bg-amber-300/10 text-amber-100',
};

export const scopeDescriptions = {
  protocol: 'Axodus ecosystem, constitutional policy, global registry and protocol health.',
  user: 'Connected wallet, permissions, progress, ownership and personal activity.',
  tenant: 'Selected DAO, company, Sub-DAO, workspace, treasury and local operations.',
  operator: 'Admin, ACS, triage, review, support and execution-control visibility.',
};
